// extracted by mini-css-extract-plugin
export default {"questionBorder":"QuestionsBucket_questionBorder__3oXqq","title":"QuestionsBucket_title__2Vyn1"};